<template>
  <b-modal id="assignments-list-modal" hide-header-close
           :modal-class="`adp-modal`"
           :header-class="`adp-modal-header mb-0 pb-2`"
           :body-class="`adp-modal-body`"
           :footer-class="`adp-modal-footer d-flex justify-content-center align-self-end p-2 m-2`"
           @close="reloadPage" @hide="reloadPage">
    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal" style="font-size: 22px; color: #404246">{{ $t('modal.successfully_added')}}</span>
        <span class="rounded ml-3 px-1" style="background-color: #F5F5F5; color: #57606F;">{{ userAssignmentsTotal }}</span>
      </div>
    </template>
    <template>
      <div v-for="activity, name in sortedAssignments">
        <p class="mb-2 mt-3" style="font-size: 16px;">{{ $t('catalog.learning') }}{{ name }}" {{ $t('modal.successfully_assigned') }}:</p>
        <p v-for="user, index in activity" class="mb-1">
          {{ index + 1 }}. {{ user.fullname }} {{ user.pernumber }} {{ user.fired ? ' ('+$t('modal.idp_export_fired_status_fired')+')' : '' }}
        </p>
      </div>
    </template>
    <template #modal-footer>
      <button class="btn adp-btn adp-btn__large"
              @click="reloadPage">
        {{ $t('modal.to_the_catalog')}}
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "AssignmentsListModal",
  props: {
    userAssignments: {
      type: Object,
    }
  },
  data: () => {
    return {
      userAssignmentsTotal: 0,
      sortedAssignments: {},
    }
  },
  watch: {
    userAssignments() {
      let userAssignmentsTotal = 0;
      this.sortedAssignments = {};
      for (let activityKey in this.userAssignments) {
        let name = this.userAssignments[activityKey].name
        this.userAssignmentsTotal += Object.keys(this.userAssignments[activityKey].users).length;
        this.sortedAssignments[name] = [];
        for (let userKey in this.userAssignments[activityKey].users) {
          let user = this.userAssignments[activityKey].users[userKey];
          if (user.fired === 1) {
            this.sortedAssignments[name].unshift(user);
          } else {
            this.sortedAssignments[name].push(user);
          }
        }
      }
    }
  },
  methods: {
    reloadPage() {
      this.$bvModal.hide('mass-assignments-modal');
      window.location.reload();
    }
  }
}
</script>
